const STORAGE_KEY = 'manet_ccp_account_oauth'
const MAX_AGE = 10 * 60 * 1000

function base64url(bytes) {
    return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export async function startAccountOAuth(provider) {
    const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)))
    const state = base64url(crypto.getRandomValues(new Uint8Array(32)))
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({provider: provider.toLowerCase(), state, verifier, startedAt: Date.now()}))
    return {state, code_challenge: base64url(new Uint8Array(digest))}
}

export function consumeAccountOAuth(provider, state) {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    // One attempt per flow, including failed or cancelled callbacks.
    sessionStorage.removeItem(STORAGE_KEY)
    const flow = stored ? JSON.parse(stored) : null
    if (!flow || typeof state !== 'string' || state !== flow.state ||
        flow.provider !== String(provider).toLowerCase() ||
        Date.now() - flow.startedAt > MAX_AGE || flow.startedAt > Date.now()) {
        throw new Error('Die Anmeldung ist abgelaufen oder ungültig. Bitte melden Sie sich erneut an.')
    }
    return flow.verifier
}
